/* src/app/shared/components/loader/loader.component.scss */
.spinner-container {
  display: flex;
  align-items: center;
  justify-content: center;
}
.spinner-container ::ng-deep .mat-progress-spinner circle,
.spinner-container .mat-spinner circle {
  stroke: var(--tds-blue-400);
}
/*# sourceMappingURL=loader.component.css.map */
